import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { pipelineConsultant } from 'src/Models/pipeline.model';
import { helperFunctions } from 'src/helperfunctions';

@Injectable({
  providedIn: 'root'
})
export class LookupListsService {
  constructor(private http: HttpClient, private helper:helperFunctions) { }

  public pipelineLookup:pipelineLookup = new pipelineLookup(this.http, this.helper);
}

@Injectable({
  providedIn: 'root'
})
export class pipelineLookup{
  private URL:string = environment.lookupLists.pipelineLookup_URL;

  constructor(private http: HttpClient , private helper:helperFunctions) {}

  private getList(loggedInUserID:string, startDate:string, endDate:string, actionName:string,  consultantList?:string[], countryList?:string[], officeList?:string[]){
    let body = {
      "startDate": startDate,
      "endDate": endDate,
      "consultantList": consultantList,
      "countryList": countryList,
      "officeList": officeList,
      "actionName": actionName,
      "loggedInUserID": loggedInUserID
    }

    return this.http.post(this.URL, body);
  }



  public PipelineWeekNumbers(loggedInUserID:string, startDate?:Date | null, endDate?:Date | null){

    return this.getList(loggedInUserID, this.helper.dateToString('yyyy-MM-dd', startDate), this.helper.dateToString('yyyy-MM-dd', endDate), environment.lookupLists.pipelineLookup_actions.PipelineWeekNumbers)
    .pipe(map((data:any) => data.response_object));
  }

  public PipelineCountries(loggedInUserID:string, startDate?:Date | null, endDate?:Date | null){
    return this.getList(loggedInUserID, this.helper.dateToString('yyyy-MM-dd', startDate), this.helper.dateToString('yyyy-MM-dd', endDate), environment.lookupLists.pipelineLookup_actions.PipelineCountries)
    .pipe(map((data:any) => data.response_object));
  }

  public PipelineOffices(loggedInUserID:string, startDate?:Date | null, endDate?:Date | null, countryList?:string[]){
    return this.getList(loggedInUserID, this.helper.dateToString('yyyy-MM-dd', startDate), this.helper.dateToString('yyyy-MM-dd', endDate), environment.lookupLists.pipelineLookup_actions.PipelineOffices,undefined,countryList)
    .pipe(map((data:any) => data.response_object));
  }

  public PipelineConsultants(loggedInUserID:string, startDate?:Date | null, endDate?:Date | null, countryList?:string[], officeList?:string[]): Observable<pipelineConsultant[]>{
    return this.getList(loggedInUserID, this.helper.dateToString('yyyy-MM-dd', startDate), this.helper.dateToString('yyyy-MM-dd', endDate), environment.lookupLists.pipelineLookup_actions.PipelineConsultants, undefined, countryList, officeList)
    .pipe(map((data:any) => data.response_object));
  }

}
